import Request from "../../../services/request";

export const emptyBranch = () => ({
  id: null,
  id_company: null,
  id_city: null,
  name: null,
  physical_address: null,
  yandex_maps_url: null,
  telephone: null,
  email: null,
  lat: null,
  long: null,
  id_director: null,
  id_manager: null,
});

export default {
  namespaced: true,
  state: {
    listBranches: [],
    listCities: [],
  },
  mutations: {
    changeListBranches(state, array) {
      state.listBranches = [];
      if (Array.isArray(array)) {
        state.listBranches = array;
      } else if (array) {
        state.listBranches = Object.values(array);
      }
    },
    addBranch(state, branch) {
      state.listBranches.push({ ...emptyBranch(), ...branch });
    },
    updateBranchAt(state, { index, data }) {
      state.listBranches.splice(index, 1, {
        ...state.listBranches[index],
        ...data,
      });
    },
    removeBranchAt(state, index) {
      state.listBranches.splice(index, 1);
    },
    clearListBranches(state) {
      state.listBranches = [];
    },
    changeListCities(state, array) {
      state.listCities = [];
      if (Array.isArray(array)) {
        state.listCities = array;
      } else if (array) {
        state.listCities = Object.values(array);
      }
    },
  },
  actions: {
    async getListBranches({ commit }, idCompany) {
      if (!idCompany) {
        commit("clearListBranches");
        return;
      }

      const query = Request.modifyQuery({ id_company: idCompany }, ["*"]);
      const response = await Request.get(
        this.state.BASE_URL + `/dictionary/company-branches${query}`
      );

      if (!response || response.isError) {
        commit("clearListBranches");
        return;
      }

      commit("changeListBranches", response.data);
    },

    async getListCities({ commit, state }) {
      if (state.listCities.length) return;

      const response = await Request.get(
        `${this.state.BASE_URL}/dictionary/cities?select[]=id&select[]=city`
      );

      if (!response || response.isError) return;

      commit("changeListCities", response.data);
    },

    async getNearestCity({ commit }, { lat, long }) {
      try {
        const response = await Request.get(
          `${this.state.BASE_URL}/dictionary/cities/nearest?lat=${lat}&long=${long}`
        );

        if (!response || response.isError) return null;

        return response.data;
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
        return null;
      }
    },

    async createBranch({ commit }, branch) {
      try {
        return await Request.post(
          this.state.BASE_URL + "/dictionary/company-branches",
          branch
        );
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
      }
    },

    async updateBranch({ commit }, branch) {
      try {
        return await Request.put(
          this.state.BASE_URL + "/dictionary/company-branches/" + branch.id,
          branch
        );
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
      }
    },

    async deleteBranch({ commit }, id) {
      try {
        return await Request.delete(
          this.state.BASE_URL + "/dictionary/company-branches/" + id
        );
      } catch (e) {
        console.log(e);
        commit("change_notification_modal", e, { root: true });
      }
    },
  },
  getters: {},
};
